var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"error--text",attrs:{"label":_vm.label,"input-value":_vm.value,"value":_vm.value,"disabled":_vm.disabled,"persistent-hint":!!_vm.info,"hint":_vm.info,"rules":_vm.required ? _vm.isRequired : []},on:{"change":function($event){return _vm.$emit('change', {val: $event, name: _vm.name})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }